import { useEffect, useState } from "react";
import { useGetLocalDateTimeQuery } from "../../../app/services/middleware";

import styles from "../../../styles/clockDisplay.module.css";

const ClockDisplay = () => {

    const [timeValue, setTimeValue] = useState(0);
    const result = useGetLocalDateTimeQuery();

    useEffect(() => {
        if (result.status === 'fulfilled') {  
            let dt = new Date(result.data);

            const intervalGetTime = setInterval(() => {
                let newTime = new Date(dt.setSeconds( dt.getSeconds() + 1)).toLocaleTimeString()
                setTimeValue(newTime);
            }, 1000);
            return () => clearInterval(intervalGetTime);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [result]);

    return (
        <>
        {
            timeValue !== 0 && ( <span className={styles.clock}>{ timeValue }</span> )
        }
        </>
    )
}

export default ClockDisplay;